import { useCallback, useMemo } from "react";

import { useCurrentUser } from "@/contexts";
import { useScopedHref } from "@/hooks";

import { NavLinkItemType } from "./NavLink.types";

export const useGetNavLinkPath = () => {
  const currentUser = useCurrentUser();
  const scopedHref = useScopedHref();

  const NAV_LINK_PATHS: { [key in NavLinkItemType]: string } = useMemo(
    () => ({
      clubs: "/operators",
      platforms: "/platforms",
      sports: "/sports",
      disciplines: "/disciplines",
      thirdPartyLicenses: "/third-party-license",
      platformManagers: "/platforms/manage/current/management",
      platformSettings: `/platforms/manage/current`,
      organizationSettings: `/entities/edit/current`,
      userSettings: `/users/edit/${currentUser.id}`,
      venues: "/operators",
      tournaments: "/tournaments/inProgressUpcoming",
      users: "/users",
      organizations: "/entities",
      licenses: "/licenses",
      certificates: "/certificates",
      issuedCertificates: "/issued-certificates",
      applicationForms: "/application-forms",
      issuedApplicationForms: "/submitted-application-forms",
      issuedLicenses: "/issued-licenses",
      specificVenue: "/venues/:venueId",
      leagues: "/tours",
      home: "/",
      news: "/news",
      gallery: "/albums",
      stripeConnect: "/stripe-accounts",
      platformStripeAccounts: "/platform-stripe-accounts",
      documents: "/documents",
      pages: "/pages",
      banners: "/banners",
      partners: "/partners",
      transactions: "/transactions",
      paymentsHistory: "/payments-history",
      integrations: "/integrations",
      helpCenter: "https://discord.gg/mzhdJAU9NX",
      tutorials: "https://tournated.gitbook.io/tournated/tournated-portals/tournated-dashboard",
      contactSupport: "mailto:hello@tournated.com",
      coaches: "/coaches",
      teams: "/teams",
      managementTeam: "/management-team",
      auditLogs: "/audit-logs",
      documentation: "/documentation",
    }),
    [currentUser.id]
  );

  const getNavLinkPath = useCallback(
    (type: NavLinkItemType) => scopedHref(NAV_LINK_PATHS[type]),
    [NAV_LINK_PATHS, scopedHref]
  );

  return getNavLinkPath;
};
